import React from 'react';
import { LoadingContainer, LoadingImage } from './styles';

export default function LoadingSkeleton() {
  return (
    <LoadingContainer data-testid="Loading">
      <LoadingImage />
    </LoadingContainer>
  );
}